import { Injectable } from "@angular/core";
import { MunicipalityHelper } from "@app/project/model/municipality";
import { MunicipalityDbService } from "@app/project/services/municipality-db.service";
import { ActionWord } from "@app/shared/resources/action-word";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import { DataActions, MunicipalityActions } from "../actions";

@Injectable()
export class MunicipalityEffects {
    constructor(private actions$: Actions, private dbService: MunicipalityDbService) {}

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MunicipalityActions.load),
            switchMap(({ projectId }) =>
                DataActions.toAction2()(
                    this.dbService.getProjectMunicipalities(projectId).pipe(map(municipality => ({ municipality }))),
                    MunicipalityActions.loadSuccess,
                    MunicipalityActions.loadFailure
                )
            )
        )
    );

    create$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MunicipalityActions.create),
            switchMap(({ municipality, callbackEmitter }) =>
                DataActions.toAction2()(
                    this.dbService.create(municipality).pipe(map(municipality => ({ municipality }))),
                    MunicipalityActions.createSuccess,
                    MunicipalityActions.createFailure,
                    callbackEmitter
                )
            )
        )
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MunicipalityActions.update),
            switchMap(({ municipality, callbackEmitter }) =>
                DataActions.toAction2()(
                    this.dbService.update(municipality).pipe(map(() => ({ municipality }))),
                    MunicipalityActions.updateSuccess,
                    MunicipalityActions.updateFailure,
                    callbackEmitter
                )
            )
        )
    );

    upsertSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MunicipalityActions.createSuccess, MunicipalityActions.updateSuccess),
            map(DataActions.handleSuccessMessage2(ActionWord.saved, null, MunicipalityHelper.dbTypeName))
        )
    );
}
